import { render, staticRenderFns } from "./LocalizedInput.vue?vue&type=template&id=455d34ce&scoped=true"
import script from "./LocalizedInput.vue?vue&type=script&lang=js"
export * from "./LocalizedInput.vue?vue&type=script&lang=js"
import style0 from "./LocalizedInput.vue?vue&type=style&index=0&id=455d34ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "455d34ce",
  null
  
)

export default component.exports